var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _ellipse, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveyUserIndividual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 67,
    viewBox: "0 0 60 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 42,
    height: 42,
    fill: "#F0F0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 3,
    fill: "#C9C9C9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.85083,
    y: 10.5742,
    width: 23.791,
    height: 4,
    fill: "#C9C9C9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.85083,
    y: 21.1484,
    width: 23.791,
    height: 4,
    fill: "#C9C9C9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.85083,
    y: 31.7217,
    width: 23.791,
    height: 4,
    fill: "#C9C9C9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 42,
    height: 46,
    fill: "url(#paint0_linear_2091_25761)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2091_25761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 32,
    width: 34,
    height: 35
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43,
    cy: 49.2429,
    rx: 17,
    ry: 17.2429,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2091_25761)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.8792,
    y: 28.6035,
    width: 47.9091,
    height: 44.4134,
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1311 52.7387C44.4809 52.7387 45.8004 52.3327 46.9226 51.5719C48.0448 50.8111 48.9193 49.7299 49.4356 48.4649C49.9518 47.1999 50.0865 45.808 49.8227 44.4653C49.5588 43.1227 48.9083 41.8895 47.9534 40.922C46.9984 39.9544 45.782 39.2958 44.458 39.0296C43.134 38.7633 41.7618 38.9014 40.5152 39.4263C39.2685 39.9512 38.2034 40.8393 37.4545 41.9784C36.7056 43.1174 36.3066 44.4561 36.308 45.8252C36.308 46.7337 36.4845 47.6333 36.8275 48.4725C37.1705 49.3118 37.6732 50.0742 38.3069 50.7163C38.9405 51.3584 39.6928 51.8675 40.5206 52.2145C41.3483 52.5615 42.2354 52.7397 43.1311 52.7387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6268 69.4179C58.6268 60.7423 51.6916 56.0456 43.1311 56.0456C34.5707 56.0456 27.6214 60.7423 27.6214 69.4179C27.6214 69.4179 26.2052 73.2815 43.1241 73.2815C60.043 73.2815 58.6268 69.4179 58.6268 69.4179Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2091_25761",
    x1: 21,
    y1: 18,
    x2: 21,
    y2: 59.2083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyUserIndividual);
export default __webpack_public_path__ + "static/media/survey-user-individual.bf5ccbec030546cab63c4ddb1cccafd3.svg";
export { ForwardRef as ReactComponent };